<template></template>
<script>
  export default {
    name: 'additional-response-default'
  }
</script>